module.exports = __webpack_public_path__ + "static/img/FullBodyXRAY5.41cbbb95.jpg";